export default __webpack_public_path__ + "static/media/shape.47f7eca8.svg";